import { render, staticRenderFns } from "./exhibit-detail.vue?vue&type=template&id=6c2fbe3e&scoped=true"
import script from "./exhibit-detail.vue?vue&type=script&lang=js"
export * from "./exhibit-detail.vue?vue&type=script&lang=js"
import style0 from "./exhibit-detail.vue?vue&type=style&index=0&id=6c2fbe3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2fbe3e",
  null
  
)

export default component.exports